module.exports = __webpack_public_path__ + "media/img/frontend_application/footericon/blog-e6c525847e412e2b3b56c627e323c6dc.svg";